(() => {
  if (window.LimitedEditionAnimationsLoaded) return;
  window.LimitedEditionAnimationsLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = (root = document) => {
    const items = Array.from(root.querySelectorAll('.limited-page [data-reveal]'));
    if (!items.length) return;

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    items.forEach((el) => observer.observe(el));
  };

  const animateCounts = (root = document) => {
    const counters = Array.from(root.querySelectorAll('[data-count-to]'));
    if (!counters.length) return;

    const run = (el) => {
      const target = parseFloat(el.getAttribute('data-count-to'));
      if (Number.isNaN(target)) return;

      const duration = Math.max(600, parseInt(el.getAttribute('data-count-duration') || '1200', 10));
      const suffix = el.getAttribute('data-count-suffix') || '';
      const prefix = el.getAttribute('data-count-prefix') || '';

      if (reduceMotion) {
        el.textContent = `${prefix}${target}${suffix}`;
        return;
      }

      let start = null;
      const from = 0;
      const step = (timestamp) => {
        if (!start) start = timestamp;
        const progress = Math.min((timestamp - start) / duration, 1);
        const current = Math.round(from + (target - from) * progress);
        el.textContent = `${prefix}${current}${suffix}`;
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    };

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      counters.forEach(run);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            run(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    counters.forEach((el) => observer.observe(el));
  };

  const init = (root = document) => {
    reveal(root);
    animateCounts(root);
    initLeNav(root);
  };

  const initLeNav = (root = document) => {
    const nav = root.querySelector('#le-nav') || document.getElementById('le-nav');
    if (!nav) return;

    const btns = Array.from(nav.querySelectorAll('.le-nav__btn'));
    const watches = Array.from(document.querySelectorAll('[data-le-watch-index]'));
    const tooltip = document.getElementById('le-nav-tooltip');

    if (!btns.length || !watches.length) return;

    // ── Smooth scroll on click ──────────────────────────────────────────
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.target;
        const target = document.getElementById(targetId);
        if (!target) return;
        const navHeight = nav.getBoundingClientRect().height;
        const top = target.getBoundingClientRect().top + window.scrollY - navHeight - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      });

      // ── Floating tooltip: show on hover ────────────────────────────────
      if (tooltip) {
        btn.addEventListener('mouseenter', () => {
          const title = btn.dataset.title || btn.getAttribute('aria-label') || '';
          if (!title) return;

          tooltip.textContent = title;
          tooltip.classList.add('is-visible');

          // Position tooltip centred under the hovered button
          const btnRect = btn.getBoundingClientRect();
          const navRect = nav.getBoundingClientRect();
          const centreX = btnRect.left - navRect.left + btnRect.width / 2;
          tooltip.style.left = centreX + 'px';
        });

        btn.addEventListener('mouseleave', () => {
          tooltip.classList.remove('is-visible');
        });
      }
    });

    // ── Scroll spy: highlight active thumbnail ──────────────────────────
    if (typeof IntersectionObserver !== 'undefined') {
      const setActive = (brandHandle) => {
        btns.forEach((b) => b.classList.toggle('is-active', b.dataset.brand === brandHandle));
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const brandHandle = entry.target.getAttribute('data-le-watch-brand');
              setActive(brandHandle);
            }
          });
        },
        { rootMargin: '-25% 0px -55% 0px', threshold: 0 }
      );

      watches.forEach((w) => observer.observe(w));
    }

    // ── Shrink nav when scrolled past original position ──────────────────
    const navTop = nav.getBoundingClientRect().top + window.scrollY;
    const handleShrink = () => {
      nav.classList.toggle('is-shrunk', window.scrollY > navTop + 80);
    };
    window.addEventListener('scroll', handleShrink, { passive: true });
    handleShrink();
  };


  document.addEventListener('DOMContentLoaded', () => init());

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  }
})();

